module.exports = __webpack_public_path__ + "static/media/Kaili Zhu.f962c786.png";